module.exports = __webpack_public_path__ + "static/media/CaretRight.87c2140d.svg";